import { FC, useState } from 'react';
import { IressButton, IressCol, IressInline, IressRow, IressStack, useModal } from '@iress-oss/ids-components';
import { SkeletonElement } from '@xplan-pension-switching/common';
import { LoadingFields } from '../../LoadingFields/LoadingFields';

const loadingPlaceholder =
    <IressStack gutter="lg">
        <IressRow gutter="lg">
            <IressCol span={{md: 2}}>
                <LoadingFields fields={[SkeletonElement.Button, SkeletonElement.Button]} testId='placeholder-modal-cancel-button' />
            </IressCol>
            <IressCol span={{md: 2}}>
                <LoadingFields fields={[SkeletonElement.Button, SkeletonElement.Button]} testId='placeholder-modal-continue-button' />
            </IressCol>
        </IressRow>
    </IressStack>;

export type ScenarioModalFooterProps = {
    hasFunds: boolean;
    onSubmit: () => Promise<{ success: boolean }>;
    isLoading: boolean;
};

export const ScenarioModalFooter: FC<ScenarioModalFooterProps> = ({ hasFunds, onSubmit, isLoading }) => {
    const { showModal } = useModal();
    const [pending, setPending] = useState(false);
    return <>
        {isLoading && loadingPlaceholder}
        {!isLoading && 
            (hasFunds ? (
                <IressRow gutter={'md'} verticalAlign={'middle'}>
                    <IressCol>
                        <IressInline gutter={'md'} horizontalAlign={'left'}>
                            <IressButton
                                data-testid={'scenario-modal-btn-continue'}
                                mode={'primary'}
                                type={'button'}
                                loading={pending}
                                onClick={async () => {
                                    setPending(true);
                                    const { success } = await onSubmit();
                                    if (success) {
                                        showModal('scenario-modal', false);
                                        setPending(false);
                                    } else {
                                        setPending(false);
                                    }
                                }}
                            >
                                Continue
                            </IressButton>
                            <IressButton
                                data-testid={'scenario-modal-btn-cancel'}
                                mode={'secondary'}
                                onClick={() => showModal('scenario-modal', false)}
                            >
                                Cancel
                            </IressButton>
                        </IressInline>
                    </IressCol>
                </IressRow>
            ) : (
                <IressInline gutter={'md'} horizontalAlign={'left'}>
                    <IressButton
                        data-testid={'scenario-modal-btn-ok'}
                        mode={'primary'}
                        onClick={() => showModal('scenario-modal', false)}
                    >
                        Ok
                    </IressButton>
                </IressInline>
            ))
        }
    </>
};
